import axios, { AxiosInstance } from 'axios';
import { ENV_VARIABLES } from '../common/constants';
import {
  AdminAssetsApi,
  AdminModuleRunsApi,
  AdminModulesApi,
  AdminNotificationSettingsApi,
  AdminNotificationsApi,
  AdminVideoJobsApi,
  UserAuthApi,
  UsersApi,
  QualicamApi,
  AdminRoleApi,
} from 'src/generated/rest-api/types';

export class RestAPI {
  httpClient: AxiosInstance;
  apis: {
    adminRole: AdminRoleApi;
    assets: AdminAssetsApi;
    auth: UserAuthApi;
    moduleRuns: AdminModuleRunsApi;
    modules: AdminModulesApi;
    notificationSettings: AdminNotificationSettingsApi;
    notifications: AdminNotificationsApi;
    qualicam: QualicamApi;
    users: UsersApi;
    videoJobs: AdminVideoJobsApi;
  };

  constructor() {
    const basePath = ENV_VARIABLES.REST_API_URL;
    this.httpClient = axios.create();

    this.apis = {
      adminRole: new AdminRoleApi(undefined, basePath, this.httpClient),
      assets: new AdminAssetsApi(undefined, basePath, this.httpClient),
      auth: new UserAuthApi(undefined, basePath, this.httpClient),
      moduleRuns: new AdminModuleRunsApi(undefined, basePath, this.httpClient),
      modules: new AdminModulesApi(undefined, basePath, this.httpClient),
      notifications: new AdminNotificationsApi(
        undefined,
        basePath,
        this.httpClient,
      ),
      notificationSettings: new AdminNotificationSettingsApi(
        undefined,
        basePath,
        this.httpClient,
      ),
      qualicam: new QualicamApi(undefined, basePath, this.httpClient),
      users: new UsersApi(undefined, basePath, this.httpClient),
      videoJobs: new AdminVideoJobsApi(undefined, basePath, this.httpClient),
    };
  }
}

export const RestAPIInstance = new RestAPI();
